import { call, put, takeEvery } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import * as types from './RADListActionType';
import * as actions from './RADListActions';
import * as services from './RADListServices';

// Fetch Provider List
function* fetchRadListSaga(action) {
    try {
        const response = yield call(services.getAllRadList, action.payload);
 
        if (response?.success) {
            const data = {
                isCustomView: response.values?.IsCustomView || false,
                fieldName: response.values?.fieldName || [],
                fieldValues: response.values?.fieldValues || [],
                data: response.values?.data || [] // fallback for default
            };
            yield put(actions.fetchRadListSuccess(data));
        } else {
            yield put(actions.fetchRadListFailure('No data found'));
        }
    } catch (error) {
        console.error('Provider List Fetch Error:', error);
        yield put(actions.fetchRadListFailure('Failed to fetch Provider list'));
        Swal.fire('Error', 'Failed to load Provider List', 'error');
    }
}

function* dropdownFilterSaga(action) {
    try {
        const response = yield call(services.getDropdownFilterData, action.payload);
        if (response?.success) {
            yield put(actions.dropdownFilterSuccess(response.values || []));
        } else {
            yield put(actions.dropdownFilterFailure('No data found'));
        }
    } catch (error) {
        console.error('Dropdown Filter Fetch Error:', error);
        yield put(actions.dropdownFilterFailure('Failed to fetch dropdown filter data'));
        Swal.fire('Error', 'Failed to load Dropdown Filter Data', 'error');
    }
}

export default function* watchRADListSaga() {
    yield takeEvery(types.FETCH_RADLIST_REQUEST, fetchRadListSaga);
    yield takeEvery(types.DROPDOWN_FILTER_REQUEST, dropdownFilterSaga);
}